const areSpecificValuesFilled = (obj, columns) => {
	return columns.every(
		(column) =>
			obj[column] !== null && obj[column] !== undefined && obj[column] !== ""
	);
};

export default areSpecificValuesFilled;
